/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex, Text } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Route from 'solis/route';
import Galaxy from 'solis/application/galaxy';

import Icon from 'solis/claude/primitive/icon';
import ColonyIcon from 'solis/claude/element/colony.icon';


export default () =>
{
  const route = use(Route);

  const colony = use(Galaxy).getColony(route.getArg('id'));

  return (
    <Flex align = 'center' gap = '2'>
      <Icon size = '2'><ColonyIcon /></Icon>
      <Text size = '2' weight = 'medium'>{colony.getName()}</Text>
    </Flex>
  );
};
